import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'SUBJECT'

export type SubjectState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function subjectReducer(state: SubjectState = initialState, action: AnyAction): SubjectState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
